import { News } from 'all-in-one-shared-api';
import { NewsProps } from 'types/home';

const MAXIMUM_NUMBER_OF_NEWS = 5;

export const formatNews = (news: News[] | undefined, isEnglish: boolean, token: string): NewsProps[] | undefined => {
  if (!news) return undefined;
  const formattedNews = news.map((newItem) => {
    const { title, chineseTitle, message, chineseMessage, link, chineseLink, imageUrl } = newItem;
    return {
      title: isEnglish ? title : chineseTitle,
      description: isEnglish ? message : chineseMessage,
      url: isEnglish ? link : chineseLink,
      imgSrc: `${imageUrl}?token=${token}`,
    };
  });
  // Note(Andy Chow): The news fetched from api is already ordered by Mesg_Priority. Maximum 5 news according to https://generali-hk.atlassian.net/browse/AIOBRB-1647
  return formattedNews.slice(0, MAXIMUM_NUMBER_OF_NEWS);
};
